import React from 'react';
import styles from './AdvancedFilter.module.scss';
import { FormattedMessage } from 'react-intl';
import { getEventName } from 'utils/widgetUtils';
import { Check } from '@mui/icons-material';

const AdvancedFilterMultiSelectFilter = ({
  filterSchema,
  filterKey,
  onChange,
  activeOptions,
}) => {
  const { options, displayAsIs, customOptions } = filterSchema;

  const getFilterName = (filter, element, displayAsIs) => {
    if (!filter || !element) {
      return '';
    }

    if (displayAsIs) {
      return element;
    }

    if (filter.toUpperCase().includes('BRIGHTCLOUD_ID')) {
      return `${getEventName('BRIGHTCLOUD_ID', element.toString())}`;
    }

    let id = 'GENERAL.UNKNOWN';

    if (element && element.toString() !== '') {
      if (filter.toUpperCase().includes('COUNTRY')) {
        id = `COUNTRIES.${element.toString().toUpperCase()}`;
      } else if (filter.toUpperCase().includes('IP') && filter !== 'type_ips') {
        id = `${element.toString().toUpperCase()}`;
      } else {
        id = `FILTERS.${filter.toUpperCase()}.${element
          .toString()
          .toUpperCase()}`;
      }
    }

    return <FormattedMessage id={id} />;
  };

  const optionIsActive = (element) => {
    return (
      activeOptions &&
      activeOptions.length > 0 &&
      activeOptions.includes(element)
    );
  };

  return (
    <>
      {options.map((option, index) => (
        <div key={index}>
          <div
            className={`${styles['element-check']} d-flex align-items-center justify-content-between pr-2`}
          >
            <p
              onClick={() => onChange(option)}
              className={`${styles['filter-element']} mb-0 pl-2 py-3`}
            >
              {getFilterName(filterKey, option, displayAsIs)}
            </p>
            <Check
              className={
                optionIsActive(option) ? styles['check'] : styles['hide-check']
              }
            />
          </div>
          <div>
            {customOptions?.[option]?.element &&
            activeOptions &&
            activeOptions.length > 0 ? (
              <>{customOptions[option].element}</>
            ) : null}
          </div>
        </div>
      ))}
    </>
  );
};

export default AdvancedFilterMultiSelectFilter;
